import api from '@/plugins/api';
import { checkError, cloneDeep, prepareApiParams } from 'erp-skeleton-library/utils';

const template = {
  id: 0,
  question: null,
  order: null,
}

const state = {
  tableLoading: false,
  allPraTaskQuestions: [],
  registerPraTaskQuestion: {
    id: 0,
    question: null,
    order: null,
  },
  headers: [
    {
      text: 'Questão',
      align: 'left',
      value: 'question',
      sortable: false,
    },
  ],
};

const mutations = {
  LIST(state, payload) {
    state.allPraTaskQuestions = payload;
    state.tableLoading = false;
  },
  SET(state, payload) {
    state.registerPraTaskQuestion = cloneDeep(payload ?? template);
  },
};

const actions = {
  create({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.post('pra/tasks/' + payload.task + '/questions', payload)
         .then(response => {
           resolve(response.data);
         }).catch(error => {
        checkError(error.response.status);
        reject(error.response);
      });
    });
  },
  list({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let query = prepareApiParams(payload, 'id,question,order');
      state.tableLoading = true;

      api.get('pra/tasks/' + payload.task + '/questions?' + new URLSearchParams(query).toString())
         .then(response => {
           commit('LIST', response.data.entities);
           resolve(response.data);
         })
         .catch(error => {
           checkError(error.response.status);
           reject(error.response);
         });
    });
  },
  read({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get('pra/tasks/' + payload.task + '/questions/' + payload.id)
         .then(response => {
           commit('SET', response.data);
           resolve(response.data);
         }).catch(error => {
        checkError(error.response.status);
        reject(error.response);
      });
    });
  },
  update({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.put('pra/tasks/' + payload.task + '/questions/' + payload.id, payload)
         .then(response => {
           resolve(response.data);
         }).catch(error => {
        checkError(error.response.status);
        reject(error.response);
      });
    });
  },
  delete({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.delete('pra/tasks/' + payload.task + '/questions/' + payload)
         .then((response) => {
           resolve(response.data);
         })
         .catch((error) => {
           checkError(error.response.status);
           reject(error.response);
         });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
